import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Row, Col } from 'antd'
import moment from 'moment'
import _ from 'lodash'

import * as actions from './ActiveProjectPageActions'
import DocumentList from '../Commons/DocumentList/DocumentList'
import MemberList from '../Commons/MemberList/MemberList'
import PreviewPanel from '../Commons/PreviewPanel/PreviewPanel'
import PaymentBlock from '../Commons/PaymentBlock/PaymentBlock'
import './ActiveProjectPage.scss'

export class ActiveProjectPage extends Component {
    constructor(props) {
        super(props)

        let tableHeader = '',
            projectStatus = ''

        if (props.location.pathname === '/workdesk/active-project') {
            tableHeader = 'Active Project'
            projectStatus = 'active'
        } else if (props.location.pathname === '/workdesk/proposed-project') {
            tableHeader = 'Proposed Project'
            projectStatus = 'proposed'
        } else if (props.location.pathname === '/workdesk/history') {
            tableHeader = 'History'
            projectStatus = 'history'
        }

        this.state = {
            parentColumns: [
                { title: tableHeader, dataIndex: 'name', key: 'name', width: 250 },
                { title: 'Estate Name', dataIndex: 'estate_name', key: 'estate_name', render: data => data || 'N/A', width: 130 },
                { title: 'Type', dataIndex: 'type', key: 'type', render: data => data || 'N/A' },
                { title: 'Size', dataIndex: 'size', key: 'size', render: data => data || 'N/A', width: 50 },
                { title: 'Due Date', dataIndex: 'due', key: 'due', render: due => due ? moment(due).format('DD/MM/YYYY') : 'N/A' }
            ],
            checkedDocType: [],
            projectStatus: projectStatus,
            projectList: [],
            filter: {
                category: undefined,
                type: undefined,
                size: undefined,
                siteLocation: undefined,
                estateName: undefined
            },
            searchBarInput: '',
            selectedActiveProjectIdx: null,
            selectedActiveProjectDocumentIdx: null,
            selectedActiveProjectDocumentProjectId: null,
            selectedMember: undefined
        }

        this.handleProjectChange = this.handleProjectChange.bind(this)
        this.filterProject = this.filterProject.bind(this)
        this.handleProjectCustomAlertConfirm = this.handleProjectCustomAlertConfirm.bind(this)
        this.handleDocumentCustomAlertConfirm = this.handleDocumentCustomAlertConfirm.bind(this)
    }

    isPaymentDisabled() {
        const { location } = this.props
        return (location.pathname === '/workdesk/history')
    }

    filterProject() {
        const { filter, checkedDocType, searchBarInput } = this.state
        let newProjectList = _.cloneDeep(this.props.activeProjectList)
        let filterCondition = {}

        _.forEach(filter, (value, key) => {
            if (value && key !== 'size') {
                filterCondition[_.snakeCase(key)] = value
            }
        })

        newProjectList = _.filter(newProjectList, filterCondition)

        if (filter.size) {
            switch (filter.size) {
                case '<= 300':
                    newProjectList = _.filter(newProjectList, (project) => project.size <= 300)
                    break
                case '301 - 500':
                    newProjectList = _.filter(newProjectList, (project) => project.size > 300 && project.size <= 500)
                    break
                case '501 - 800':
                    newProjectList = _.filter(newProjectList, (project) => project.size > 500 && project.size <= 800)
                    break
                case '> 800':
                    newProjectList = _.filter(newProjectList, (project) => project.size > 800)
                    break
                default:
            }
        }

        newProjectList = _.filter(newProjectList, (project) => {
            return _.filter(_.map(_.values(project), (value) => value ? value.toString().toUpperCase() : ''), (value) => value.indexOf(searchBarInput.toUpperCase()) !== -1).length !== 0
        })

        if (checkedDocType.length !== 0) {
            let convertedCheckedDocType = _.map(checkedDocType, (item) => _.kebabCase(item))

            _.map(newProjectList, (project, projectIdx) => {
                project.documents = _.filter(project.documents, (documents) => _.includes(convertedCheckedDocType, documents.type))
            })
        }

        this.setState({ projectList: newProjectList })
    }

    handleFilterChange(field, value) {
        let newFilter = _.cloneDeep(this.state.filter)
        newFilter[field] = value

        this.setState({ filter: newFilter })
    }

    handleSearchBarInputChange(value) {
        this.setState({ searchBarInput: value })
    }

    handleDocTypeFilterChange(checkedDocType) {
        this.setState({ checkedDocType })
    }

    handleDocumentPaymentChange(projectId, documentId, paymentIdx, paid, paidAt) {
        const { updateActiveProjectDocumentPaymentStatus, token } = this.props
        const { projectStatus } = this.state
        const newStatus = !paid
        updateActiveProjectDocumentPaymentStatus(token, projectId, documentId, paymentIdx, newStatus, paidAt, projectStatus)
    }

    handleDocumentInvoiceChange(projectId, documentId, paymentIdx, sent) {
        const { updateActiveProjectDocumentInvoiceStatus, token } = this.props
        const { projectStatus } = this.state
        const newStatus = !sent
        updateActiveProjectDocumentInvoiceStatus(token, projectId, documentId, paymentIdx, newStatus, projectStatus)
    }

    handleMemberAdd() {
        const { addMemberToActiveProject, token } = this.props
        const { projectList, selectedActiveProjectIdx, selectedMember } = this.state
        const projectId = projectList[selectedActiveProjectIdx]._id

        addMemberToActiveProject(token, projectId, selectedMember)
    }

    handleMemberRemove(memberId) {
        const { removeMemberFromActiveProject, token } = this.props
        const { projectList, selectedActiveProjectIdx } = this.state
        const projectId = projectList[selectedActiveProjectIdx]._id

        removeMemberFromActiveProject(token, projectId, memberId)
    }

    handleMemberChange(memberId) {
        this.setState({ selectedMember: memberId })
    }

    handleMemberAuthChange(memberId, isAuthorized) {
        const { updateActiveProjectMemberAuth, token } = this.props
        const { projectList, selectedActiveProjectIdx } = this.state
        const projectId = projectList[selectedActiveProjectIdx]._id

        updateActiveProjectMemberAuth(token, projectId, memberId, !isAuthorized)
    }

    handleProjectChange(record, idx) {
        this.setState({ selectedActiveProjectIdx: idx, selectedActiveProjectDocumentIdx: null, selectedActiveProjectDocumentProjectId: null })
    }

    handleDocumentChange(record, idx) {
        const { projectList } = this.state
        const selectedDocumentProjectIdx = _.findIndex(projectList, { _id: record.project_id })
        this.setState({ selectedActiveProjectIdx: selectedDocumentProjectIdx, selectedActiveProjectDocumentIdx: idx, selectedActiveProjectDocumentProjectId: record.project_id })
    }

    handleProjectCustomAlertConfirm(customAlertContent, customAlertDue) {
        const { updateProjectCustomAlert, token } = this.props
        const { projectList, selectedActiveProjectIdx } = this.state
        const projectId = projectList[selectedActiveProjectIdx]._id

        updateProjectCustomAlert(token, projectId, customAlertContent, customAlertDue)
    }

    handleDocumentCustomAlertConfirm(customAlertContent) {
        const { updateDocumentCustomAlert, token } = this.props
        const { projectList, selectedActiveProjectIdx, selectedActiveProjectDocumentIdx } = this.state
        const projectId = projectList[selectedActiveProjectIdx]._id
        const documentId = projectList[selectedActiveProjectIdx].documents[selectedActiveProjectDocumentIdx]._id

        updateDocumentCustomAlert(token, projectId, documentId, customAlertContent)
    }

    componentWillMount() {
        const { fetchActiveProjectList, updateSelectedProject, fetchLocationList, fetchEstateList, token } = this.props
        const { projectStatus } = this.state

        fetchLocationList(token)
        fetchEstateList(token)
        fetchActiveProjectList(token, projectStatus)
        updateSelectedProject({})
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            fetchActiveProjectList,
            refetchActiveProjectList,
            fetchActiveProjectMemberList,
            fetchActiveProjectAvailableMemberList,
            fetchProjectPreviewPanelInfo,
            fetchDocumentPreviewPanelInfo,
            updateSelectedProject,
            activeProjectList,
            activeProjectAvailableMemberList,
            token,
            location,
            isActiveProjectMemberAdding,
            isActiveProjectMemberRemoving,
            isActiveProjectMemberChangingAuth,
            isMemberAdding,
            isMemberRemoving,
            isMemberChangingAuth,
            isProjectStatusUpdating
        } = this.props
        const { projectStatus, projectList, filter, checkedDocType, searchBarInput, selectedActiveProjectIdx, selectedActiveProjectDocumentIdx, selectedActiveProjectDocumentProjectId } = this.state

        if (prevProps.location.pathname !== location.pathname) {
            let newParentsColumns = this.state.parentColumns
            const newState = {
                filter: {
                    category: undefined,
                    type: undefined,
                    size: undefined,
                    siteLocation: undefined,
                    estateName: undefined
                }
            }

            if (location.pathname === '/workdesk/active-project') {
                newParentsColumns[0].title = 'Active Project'
                this.setState({
                    ...newState,
                    parentColumns: newParentsColumns,
                    projectStatus: 'active',
                })
            } else if (location.pathname === '/workdesk/proposed-project') {
                newParentsColumns[0].title = 'Proposed Project'
                this.setState({
                    ...newState,
                    parentColumns: newParentsColumns,
                    projectStatus: 'proposed',
                })
            } else if (location.pathname === '/workdesk/history') {
                newParentsColumns[0].title = 'History'
                this.setState({
                    ...newState,
                    parentColumns: newParentsColumns,
                    projectStatus: 'history',
                })
            }
        }

        if (prevState.projectStatus !== projectStatus) {
            fetchActiveProjectList(token, projectStatus)
            this.setState({ selectedActiveProjectIdx: null, selectedActiveProjectDocumentIdx: null, selectedActiveProjectDocumentProjectId: null })
            updateSelectedProject({})
        }

        if (!_.isEqual(prevProps.activeProjectList, activeProjectList)) {
            this.setState({
                projectList: activeProjectList,
                selectedActiveProjectIdx: null,
                selectedActiveProjectDocumentIdx: null,
                selectedActiveProjectDocumentProjectId: null
            })
        }

        if (!_.isEqual(prevState.filter, filter) || !_.isEqual(prevState.checkedDocType, checkedDocType) || prevState.searchBarInput !== searchBarInput) {
            this.filterProject()
        }

        // Fetch project data when Selected Project changed or Document is unselected
        if ((prevState.selectedActiveProjectIdx !== selectedActiveProjectIdx && selectedActiveProjectIdx != null && selectedActiveProjectDocumentIdx == null) ||
            (prevState.selectedActiveProjectDocumentIdx !== selectedActiveProjectDocumentIdx && selectedActiveProjectDocumentIdx == null && selectedActiveProjectIdx != null)) {
            const projectId = projectList[selectedActiveProjectIdx]._id
            fetchActiveProjectMemberList(token, projectId)
            fetchActiveProjectAvailableMemberList(token, projectId)
            fetchProjectPreviewPanelInfo(token, projectId)
            updateSelectedProject(projectList[selectedActiveProjectIdx])
        }

        // Fetch project data when Selected Document changed
        if (prevState.selectedActiveProjectDocumentIdx !== selectedActiveProjectDocumentIdx && selectedActiveProjectDocumentIdx != null && selectedActiveProjectDocumentProjectId != null) {
            const selectedDocumentProjectIdx = _.findIndex(projectList, { _id: selectedActiveProjectDocumentProjectId })
            const selectedDocumentId = projectList[selectedDocumentProjectIdx].documents[selectedActiveProjectDocumentIdx]._id
            fetchActiveProjectMemberList(token, selectedActiveProjectDocumentProjectId)
            fetchActiveProjectAvailableMemberList(token, selectedActiveProjectDocumentProjectId)
            fetchDocumentPreviewPanelInfo(token, selectedActiveProjectDocumentProjectId, selectedDocumentId)
            updateSelectedProject(projectList[selectedDocumentProjectIdx])
        }

        // Clear the select when Available Member List updated
        if (!_.isEqual(prevProps.activeProjectAvailableMemberList, activeProjectAvailableMemberList)) {
            this.setState({ selectedMember: undefined })
        }

        // Fetch the new member data when the Member List changed
        if ((prevProps.isActiveProjectMemberAdding !== isActiveProjectMemberAdding && prevProps.isActiveProjectMemberAdding && !isActiveProjectMemberAdding) ||
            (prevProps.isActiveProjectMemberRemoving !== isActiveProjectMemberRemoving && prevProps.isActiveProjectMemberRemoving && !isActiveProjectMemberRemoving) ||
            (prevProps.isActiveProjectMemberChangingAuth !== isActiveProjectMemberChangingAuth && prevProps.isActiveProjectMemberChangingAuth && !isActiveProjectMemberChangingAuth)) {
            const projectId = projectList[selectedActiveProjectIdx]._id
            fetchActiveProjectMemberList(token, projectId)
            fetchActiveProjectAvailableMemberList(token, projectId)
        }

        // Fetch the new member data when the Member List in Header changed
        if ((prevProps.isMemberAdding !== isMemberAdding && prevProps.isMemberAdding && !isMemberAdding) ||
            (prevProps.isMemberRemoving !== isMemberRemoving && prevProps.isMemberRemoving && !isMemberRemoving) ||
            (prevProps.isMemberChangingAuth !== isMemberChangingAuth && prevProps.isMemberChangingAuth && !isMemberChangingAuth)) {
            const projectId = projectList[selectedActiveProjectIdx]._id
            fetchActiveProjectMemberList(token, projectId)
            fetchActiveProjectAvailableMemberList(token, projectId)
        }

        // Fetch all related data when a project's status changed
        if (prevProps.isProjectStatusUpdating !== isProjectStatusUpdating && prevProps.isProjectStatusUpdating && !isProjectStatusUpdating) {
            refetchActiveProjectList(token, projectStatus)
            updateSelectedProject({})
            this.setState({ selectedActiveProjectIdx: null, selectedActiveProjectDocumentIdx: null, selectedActiveProjectDocumentProjectId: null })
        }
    }

    render() {
        const { userId, userType, updateSelectedProject, activeProjectList, activeProjectMemberList, activeProjectAvailableMemberList, activeProjectPreviewPanelInfo, locationList, estateList } = this.props
        const { selectedActiveProjectIdx, selectedActiveProjectDocumentIdx, selectedActiveProjectDocumentProjectId, filter, searchBarInput, projectStatus, projectList, parentColumns, checkedDocType, selectedMember } = this.state
        const selectedActiveProject = projectList[selectedActiveProjectIdx] || {}

        const { created_by, members, contact_person } = selectedActiveProject
        const isAuthorized = created_by === userId || _.find(members, { member_id: userId, able_to_create: true }) || contact_person === userId || userType === 'admin'
        const childColumns = [{
            title: '',
            dataIndex: 'name',
            key: 'name',
            render: (name, record) => <NavLink to={`/workdesk/project/${record.project_id}/document/${record._id}`} activeClassName="active-link">{name}</NavLink>
        }, {
            title: 'Payment',
            dataIndex: 'terms_and_conditions.payments',
            key: 'payment',
            render: (payments, record) => payments.length !== 0 ? <PaymentBlock paymentList={payments} fieldName="paid" onClick={(paymentIdx, paid, paidAt) => this.handleDocumentPaymentChange(record.project_id, record._id, paymentIdx, paid, paidAt)} disabled={this.isPaymentDisabled()}/> : 'N/A'
        }, {
            title: 'Commencement Date',
            dataIndex: 'terms_and_conditions.commencement_date',
            key: 'commencement_date',
            render: date => date ? moment(date).format('DD/MM/YYYY') : 'N/A'
        }, {
            title: 'Completion Date',
            dataIndex: 'terms_and_conditions.working_period',
            key: 'completion_date',
            render: (period, record) => period ? moment(record.commencement_date).add(period, 'days').format('DD/MM/YYYY') : 'N/A'
        }, {
            title: 'Invoice',
            dataIndex: 'terms_and_conditions.payments',
            key: 'invoice',
            render: (payments, record) => payments.length !== 0 ? <PaymentBlock paymentList={payments} fieldName="invoice_sent" onClick={(paymentIdx, sent) => this.handleDocumentInvoiceChange(record.project_id, record._id, paymentIdx, sent)} disabled={this.isPaymentDisabled()}/> : 'N/A'
        }]

        return (
            <div className="ActiveProjectPage">
                <Row gutter={8}>
                    <Col span={20}>
                        <DocumentList
                            projectStatus={projectStatus}
                            checkedDocType={checkedDocType}
                            parentColumns={parentColumns}
                            childColumns={childColumns}
                            dataset={projectList}
                            originalDataset={activeProjectList}
                            filter={filter}
                            searchBarInput={searchBarInput}
                            locationList={locationList}
                            estateList={estateList}
                            selectedProjectIdx={selectedActiveProjectIdx}
                            selectedDocumentIdx={selectedActiveProjectDocumentIdx}
                            selectedDocumentProjectId={selectedActiveProjectDocumentProjectId}
                            onFilterChange={(field, value) => this.handleFilterChange(field, value)}
                            onDocTypeFilterChange={(checkboxList) => this.handleDocTypeFilterChange(checkboxList)}
                            onSearchBarInputChange={(value) => this.handleSearchBarInputChange(value)}
                            onProjectChange={(record, idx) => this.handleProjectChange(record, idx)}
                            onDocumentChange={(record, idx) => this.handleDocumentChange(record, idx)}
                            modalBtnText="Attach"
                            modalRedirect={(projectId, type) => `/workdesk/project/${projectId}/document/new?type=${type}`}
                            beforeCreateNewProject={(projectIdx) => updateSelectedProject(projectList[projectIdx])}
                            onCreateNewProject={() => updateSelectedProject({})}
                            disabled={projectStatus === 'history'}
                        />
                    </Col>
                    <Col span={4}>
                        <Row>
                            <MemberList 
                                isAuthorized={isAuthorized}
                                selectedProjectName={selectedActiveProject.name}
                                selectedMember={selectedMember}
                                memberList={activeProjectMemberList}
                                availableMemberList={activeProjectAvailableMemberList}
                                onMemberAdd={(memberId) => this.handleMemberAdd(memberId)}
                                onMemberRemove={(memberId) => this.handleMemberRemove(memberId)}
                                onMemberChange={(memberId) => this.handleMemberChange(memberId)}
                                onMemberAuthChange={(memberId, isAuthorized) => this.handleMemberAuthChange(memberId, isAuthorized)}
                            />
                            <PreviewPanel
                                previewInfo={activeProjectPreviewPanelInfo}
                                selectedProject={selectedActiveProject}
                                onProjectCustomAlertConfirm={(customAlertContent, customAlertDue) => this.handleProjectCustomAlertConfirm(customAlertContent, customAlertDue)}
                                onDocumentCustomAlertConfirm={(customAlertContent) => this.handleDocumentCustomAlertConfirm(customAlertContent)}
                            />
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        userId: state.auth.userId,
        userType: state.auth.userType,
        isMemberAdding: state.app.isMemberAdding,
        isMemberRemoving: state.app.isMemberRemoving,
        isMemberChangingAuth: state.app.isMemberChangingAuth,
        isProjectStatusUpdating: state.app.isProjectStatusUpdating,
        locationList: state.app.locationList,
        estateList: state.app.estateList,
        selectedActiveProjectIdx: state.activeProjectPage.selectedActiveProjectIdx,
        activeProjectList: state.activeProjectPage.activeProjectList,
        activeProjectMemberList: state.activeProjectPage.activeProjectMemberList,
        activeProjectAvailableMemberList: state.activeProjectPage.activeProjectAvailableMemberList,
        activeProjectPreviewPanelInfo: state.activeProjectPage.activeProjectPreviewPanelInfo,
        isActiveProjectMemberAdding: state.activeProjectPage.isActiveProjectMemberAdding,
        isActiveProjectMemberRemoving: state.activeProjectPage.isActiveProjectMemberRemoving,
        isActiveProjectMemberChangingAuth: state.activeProjectPage.isActiveProjectMemberChangingAuth
    }
}

export default connect(mapStateToProps, actions)(ActiveProjectPage)


// WEBPACK FOOTER //
// ./src/ActiveProjectPage/ActiveProjectPage.js